import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Excel from '../../images/officeicon/excel.png';

const CustomIconButton = styled(IconButton)((props) => ({
  borderRadius: '100%',
  backgroundColor: props.backgroundcolor,
  padding: 0,
  width: props.width,
  maxWidth: props.width,
  minWidth: props.width,
  height: props.height,
  marginRight: props.marginright,
  boxShadow: props.boxshadow,
  '&:hover': {
    backgroundColor: props.backgroundcolorhover,
  },
  '&.active': {
    backgroundColor: props.backgroundcolorhover,
  },
}));

function ExcelIconButton({
  width,
  height,
  marginright,
  boxshadow,
  backgroundcolor,
  backgroundcolorhover,
  colorhover,
  handleClick,
}) {
  return (
    <CustomIconButton
      aria-label="download-excel"
      width={width}
      height={height}
      marginright={marginright}
      boxshadow={boxshadow}
      backgroundcolor={backgroundcolor}
      backgroundcolorhover={backgroundcolorhover}
      colorhover={colorhover}
      onClick={handleClick}
    >
      <img width="100%" height="auto" src={Excel} alt="excel-download" />
    </CustomIconButton>
  );
}

ExcelIconButton.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  marginright: PropTypes.number,
  boxshadow: PropTypes.string,
  backgroundcolor: PropTypes.string,
  backgroundcolorhover: PropTypes.string,
  colorhover: PropTypes.string,
  handleClick: PropTypes.func,
};
ExcelIconButton.defaultProps = {
  width: 45,
  height: 45,
  marginright: 0,
  boxshadow: '',
  backgroundcolor: 'transparent',
  backgroundcolorhover: 'transparent',
  colorhover: 'transparent',

};

export default ExcelIconButton;
